// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"PositionTooltip_tooltip__1QpHC"};